<section class="jumbotron">
  <div class="jumbotron-content text-white text-center">
    <h1 class="font-weight-bolder text-title-header">Lo último en tecnología<br>LIDAR</h1>
    <span class="italic-title italic-title--small"><i>Somos el distribuidor exclusivo de la mejor tecnología LiDAR en el
        mundo.</i> </span> <br>
  </div>
</section>
<section class="bg-green-qaira">
  <div class="container py-4 text-center text-white">
    <p class="p-subtitle text-center">Un mapeador versátil basado en tecnología SLAM que hace que la captura de datos
      sea rápida, simple y segura. Hovermap es una unidad de escaneo móvil inteligente que tiene las mismas capacidades
      sobre o bajo tierra, en espacios interiores o exteriores. Es ideal para inspeccionar activos en entornos
      peligrosos o sin cobertura de GPS.</p>
  </div>
</section>
<section class="bg-rawview-description">
  <div class="container">
    <div class="q-description">
      <h2>Hovermap <span style="color: #1a5baa;">ST</span></h2>
      <div class="media">
        <img src="../../../../assets/img/SOLUCIÓN/INDUSTRIAL/01.svg" width="50" height="50" class="mr-3" alt="...">
        <div class="media-body">
          <h5 class="mt-0">SLAM de clase mundial</h5>
          <p>Localización y navegación fiables y precisas sin necesidad de GPS</p>
        </div>
      </div>
      <div class="media">
        <img src="../../../../assets/img/SOLUCIÓN/INDUSTRIAL/01.svg" width="50" height="50" class="mr-3" alt="...">
        <div class="media-body">
          <h5 class="mt-0">Clasificación IP65</h5>
          <p>Escanéa en áreas más peligrosas</p>
        </div>
      </div>
      <div class="media">
        <img src="../../../../assets/img/SOLUCIÓN/INDUSTRIAL/01.svg" width="50" height="50" class="mr-3" alt="...">
        <div class="media-body">
          <h5 class="mt-0">LiDAR en ángulo</h5>
          <p>Orientado a minimizar los puntos ciegos.</p>
        </div>
      </div>
      <div class="media">
        <img src="../../../../assets/img/SOLUCIÓN/INDUSTRIAL/01.svg" width="50" height="50" class="mr-3" alt="...">
        <div class="media-body">
          <h5 class="mt-0">Construcción robusta</h5>
          <p>Carcasa compuesta de plástico resistente y liviana</p>
        </div>
      </div>
      <div class="media">
        <img src="../../../../assets/img/SOLUCIÓN/INDUSTRIAL/01.svg" width="50" height="50" class="mr-3" alt="...">
        <div class="media-body">
          <h5 class="mt-0">Puerto de expansión</h5>
          <p>Expanda la capacidad de hovermap st con accesorios</p>
        </div>
      </div>
      <div class="media">
        <img src="../../../../assets/img/SOLUCIÓN/INDUSTRIAL/01.svg" width="50" height="50" class="mr-3" alt="...">
        <div class="media-body">
          <h5 class="mt-0">Ligero</h5>
          <p>Tan solo 1.6KG (3.63LB)</p>
        </div>
      </div>
    </div>
  </div>
</section>
<section>
  <div class="text-center">
    <a href="../../../../assets/Brochures/Hovermap ST brochure.pdf" target="_blank"
      class="btn custom-cta bg-yellow-qaira custom-cta--padding custom-cta--padding--lg">Conoce más aquí</a>
  </div>
</section>
<section class="bg-rawview-description bg-stx">
  <div class="container">
    <div class="q-description">
      <h2>Hovermap <span style="color: #1a5baa;">ST-X</span></h2>
      <div class="media">
        <img src="../../../../assets/img/SOLUCIÓN/INDUSTRIAL/01.svg" width="50" height="50" class="mr-3" alt="...">
        <div class="media-body">
          <h5 class="mt-0">Rango incrementado</h5>
          <p>Mayor captura de datos desde una mayor distancia.</p>
        </div>
      </div>
      <div class="media">
        <img src="../../../../assets/img/SOLUCIÓN/INDUSTRIAL/01.svg" width="50" height="50" class="mr-3" alt="...">
        <div class="media-body">
          <h5 class="mt-0">Canales Lidar</h5>
          <p style="max-width: 350px;">El doble de sensores laser generan mapas de mayor densidad con un menor tiempo de escaneo.</p>
        </div>
      </div>
      <div class="media">
        <img src="../../../../assets/img/SOLUCIÓN/INDUSTRIAL/01.svg" width="50" height="50" class="mr-3" alt="...">
        <div class="media-body">
          <h5 class="mt-0">Precisión optimizada</h5>
          <p>Mejora significativa al crear mapas con mayor precisión.</p>
        </div>
      </div>
      <div class="media">
        <img src="../../../../assets/img/SOLUCIÓN/INDUSTRIAL/01.svg" width="50" height="50" class="mr-3" alt="...">
        <div class="media-body">
          <h5 class="mt-0">Triple retorno</h5>
          <p>Para maximizar la capacitación de detalles adicionales.</p>
        </div>
      </div>      
    </div>
  </div>
</section>
<section>
  <div class="text-center">
    <a href="../../../../assets/Brochures/Hovermap ST-X.pdf" target="_blank"
      class="btn custom-cta bg-yellow-qaira custom-cta--padding custom-cta--padding--lg">Conoce más aquí</a>
  </div>
</section>
<section class="bg-rawview-logo">
  <div class="container">
    <div class="q-logo">
      <div><img width="300"
          srcset="../../../../assets/img/SOLUCIÓN/INDUSTRIAL/qaira_raw_logo@2x.png, ../../../../assets/img/SOLUCIÓN/INDUSTRIAL/qaira_raw_logo@2x.png 2x"
          src="../../../../assets/img/SOLUCIÓN/INDUSTRIAL/qaira_raw_logo@2x.png" alt="Qaira y Emesent"></div>
      <div>
        <picture>
          <source width="250" media="(max-width: 799px)"
            srcset="../../../../assets/img/SOLUCIÓN/INDUSTRIAL/q_logo_emesent_logos@2x.png">
          <img width="350"
            srcset="../../../../assets/img/SOLUCIÓN/INDUSTRIAL/q_logo_emesent_logos.png, ../../../../assets/img/SOLUCIÓN/INDUSTRIAL/q_logo_emesent_logos@2x.png 2x"
            src="../../../../assets/img/SOLUCIÓN/INDUSTRIAL/q_logo_emesent_logos.png" alt="Qaira y Emesent">
        </picture>
      </div>
    </div>
  </div>
</section>
<div>
  <!-- https://www.npmjs.com/package/angular-responsive-carousel -->
  <carousel [cellsToShow]="slidesToShow" [height]="390" autoplay="true" transitionTimingFunction="ease-in-out"
    loop="true" autoplayInterval="5000">
    <div class="carousel-cell" *ngFor="let slide of slides">
      <img [src]="getImage(slide)" alt="Imagen del carrusel" class="carousel-image" />
    </div>
  </carousel>
</div>
<div class="q-franja">
  <div class="container">
    <p>Accede a lo inaccesible con lo <strong>último en tecnología LiDAR</strong> gracias a Emesent y qAIRa.</p>
  </div>
</div>
<section class="bg-green-qaira">
  <div class="container text-center text-white">
    <h2 class="font-weight-bolder q-section__title">Conoce más sobre nosotros</h2>
    <p>¡Acompáñanos en nuestro canal de Youtube y encuentra todos nuestro videos y eventos organizados!</p>
    <div class="row py-4">
      <div class="col-lg-9">
        <iframe class="video" src="https://www.youtube.com/embed/hTiW1rlxseo?si=mnEkrJYiFnLr2vER" frameborder="0"></iframe>
      </div>
      <div class="col-lg-3">
        <div class="content-video pb-2">
          <iframe class="video_sub" src="https://www.youtube.com/embed/oNnzzMDYleQ?si=M5qxACqyw2NOV0wA" frameborder="0"></iframe>
        </div>
        <div class="content-video pb-2">
          <iframe class="video_sub" src="https://www.youtube.com/embed/k_-GXdWx6TQ?si=scXtrtxth4UndliL" frameborder="0"></iframe>
        </div>
        <!-- <div class="content-video pb-2">
          <iframe class="video_sub" src="https://www.youtube.com/embed/l04ZWun10Os" frameborder="0"></iframe>
        </div> -->
      </div>
    </div>
  </div>
</section>
<section>
  <div class="text-center">
    <a href="../../../../assets/Brochures/Hovermap ST brochure.pdf" target="_blank"
      class="btn custom-cta bg-yellow-qaira custom-cta--padding custom-cta--padding--lg">Conoce más aquí</a>
  </div>
</section>
<section class="section-land">
  <div class="container text-center text-white">
    <h1 class="font-weight-bolder mb-5 mt-5">{{'contact_home.title' | translate}}</h1>
    <p class="mb-5">{{'contact_home.subtitle' | translate}}</p>
    <a [routerLink]="['/contacto']" class="btn custom-cta mb-5 custom-cta--padding">{{'app.contact_us' | translate}}</a>
  </div>
</section>